<canvas #visualCanvas class="cm-visual-canvas"></canvas>
